import React from "react";
import { Header } from "../../../components";

const fv = (data, getMoneda, getDisplayValue) => {
  if (!data || !data.total) return "-";
  return `${getMoneda()}${getDisplayValue(data.total)}`;
};

const fp = (val, getMoneda, getDisplayValue) => {
  if (!val) return null;
  return `${getMoneda()}${getDisplayValue(val)}`;
};

export const VPHeader = ({
  vistaCompleta,
  setVistaCompleta,
  mostrar2025,
  setMostrar2025,
  showInDollars,
  setShowInDollars,
  verChileYPeru,
  setVerChileYPeru,
  pais,
  logo,
  getDesglose,
  getMoneda,
  getDisplayValue,
  getMonthName,
  currentMonthIndex,
  calcularPipeline,
  calcularPipelineFacturacion,
}) => {
  const isCierres = vistaCompleta === "cierres";
  const mesAct3 = getMonthName(currentMonthIndex).slice(0, 3).toUpperCase();
  const proxName = currentMonthIndex < 11 ? getMonthName(currentMonthIndex + 1) : "";
  const mesProx3 = proxName ? proxName.slice(0, 3).toUpperCase() : null;

  // Resúmenes — YTD incluye mes actual (todo hasta la fecha)
  const ytdCierres = getDesglose(2026, 1, currentMonthIndex + 1, "cierres");
  const ytdFact = getDesglose(2026, 1, currentMonthIndex + 1, "facturacion");
  const mesActCierres = getDesglose(2026, currentMonthIndex + 1, currentMonthIndex + 1, "cierres");
  const mesActFact = getDesglose(2026, currentMonthIndex + 1, currentMonthIndex + 1, "facturacion");
  const proxCierres =
    currentMonthIndex < 11 ? getDesglose(2026, currentMonthIndex + 2, currentMonthIndex + 2, "cierres") : null;
  const proxFact =
    currentMonthIndex < 11 ? getDesglose(2026, currentMonthIndex + 2, currentMonthIndex + 2, "facturacion") : null;

  // Forecast = confirmado + pipeline ponderado (90%×0.75 + 75%×0.50)
  const fcstCierresAct = (mesActCierres?.total || 0) + calcularPipeline(currentMonthIndex);
  const fcstCierresProx =
    currentMonthIndex < 11 ? (proxCierres?.total || 0) + calcularPipeline(currentMonthIndex + 1) : 0;
  const fcstFactAct = (mesActFact?.total || 0) + calcularPipelineFacturacion(currentMonthIndex);
  const fcstFactProx =
    currentMonthIndex < 11 ? (proxFact?.total || 0) + calcularPipelineFacturacion(currentMonthIndex + 1) : 0;

  const lbl = { color: "#222" };
  const fcst = { color: "#c57b1a" };
  const sep = { color: "#bbb" };

  return (
    <Header
      logo={logo}
      leftContent={
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 12px auto 12px minmax(15.5rem, auto) 12px auto",
            alignItems: "center",
            gap: "2px 14px",
            fontSize: "15px",
          }}
        >
          {/* Fila Cierres */}
          <strong style={{ color: "#0b4b1a" }}>Cierres</strong>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>YTD: </span>
            <span>{fv(ytdCierres, getMoneda, getDisplayValue)}</span>
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesAct3}: </span>
            <span>{fv(mesActCierres, getMoneda, getDisplayValue)}</span>
            {fcstCierresAct > (mesActCierres?.total || 0) && (
              <span style={fcst}> | {fp(fcstCierresAct, getMoneda, getDisplayValue)}</span>
            )}
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesProx3 ? `${mesProx3}: ` : "- "}</span>
            {proxCierres && proxCierres.total ? (
              <>
                <span>{fv(proxCierres, getMoneda, getDisplayValue)}</span>
                {fcstCierresProx > (proxCierres?.total || 0) && (
                  <span style={fcst}> | {fp(fcstCierresProx, getMoneda, getDisplayValue)}</span>
                )}
              </>
            ) : fcstCierresProx > 0 ? (
              <span style={fcst}>{fp(fcstCierresProx, getMoneda, getDisplayValue)}</span>
            ) : (
              <span>-</span>
            )}
          </span>
          {/* Fila Facturación */}
          <strong style={{ color: "#0c0c58" }}>Facturación</strong>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>YTD: </span>
            <span>{fv(ytdFact, getMoneda, getDisplayValue)}</span>
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesAct3}: </span>
            <span>{fv(mesActFact, getMoneda, getDisplayValue)}</span>
            {fcstFactAct > (mesActFact?.total || 0) && (
              <span style={fcst}> | {fp(fcstFactAct, getMoneda, getDisplayValue)}</span>
            )}
          </span>
          <span style={sep}>|</span>
          <span>
            <span style={lbl}>{mesProx3 ? `${mesProx3}: ` : "- "}</span>
            {proxFact && proxFact.total ? (
              <>
                <span>{fv(proxFact, getMoneda, getDisplayValue)}</span>
                {fcstFactProx > (proxFact?.total || 0) && (
                  <span style={fcst}> | {fp(fcstFactProx, getMoneda, getDisplayValue)}</span>
                )}
              </>
            ) : fcstFactProx > 0 ? (
              <span style={fcst}>{fp(fcstFactProx, getMoneda, getDisplayValue)}</span>
            ) : (
              <span>-</span>
            )}
          </span>
        </div>
      }
    >
      {/* Toggle Cierres/Facturación */}
      <div className="vp-toggle">
        <span className={`vp-toggle-label ${isCierres ? "active" : ""}`}>Cierres</span>
        <div
          className={`vp-toggle-switch ${isCierres ? "cierres" : "facturacion"}`}
          onClick={() => setVistaCompleta(isCierres ? "facturacion" : "cierres")}
        >
          <div className="vp-toggle-knob" />
        </div>
        <span className={`vp-toggle-label ${!isCierres ? "active" : ""}`}>Facturación</span>
      </div>
      {/* Checkboxes */}
      <label>
        <input type="checkbox" checked={mostrar2025} onChange={(e) => setMostrar2025(e.target.checked)} />
        Ver AA
      </label>
      <label>
        <input type="checkbox" checked={showInDollars} onChange={(e) => setShowInDollars(e.target.checked)} />
        Ver en dólares
      </label>
      <label style={{ opacity: showInDollars ? 1 : 0.5, cursor: showInDollars ? "pointer" : "not-allowed" }}>
        <input
          type="checkbox"
          checked={verChileYPeru}
          onChange={(e) => setVerChileYPeru(e.target.checked)}
          disabled={!showInDollars}
        />
        {pais === "Chile" ? "Sumar Perú" : "Sumar Chile"}
      </label>
    </Header>
  );
};
